<template>
  <div class="text-left">
    <RejectCommentLayout :comment-text="reject_comment" />
        <v-card>
          <v-form class="pa-6" ref="form">

            <!-- Button to open the SearchScopusForm modal -->
            <v-row justify="end">
              <v-btn color="primary" @click="$refs.searchScopusForm.openDialog()">
                <v-icon left>mdi-auto-fix</v-icon>
                {{  $t("form.search_scopus") }}
              </v-btn>
            </v-row>

            <!-- Include the SearchScopusForm component -->
            <SearchScopusForm ref="searchScopusForm" @use-data="handleScopusData" />

            <NewPublication
              :publication="publication"
              :mod-op_id="modOp_id"
              :disabled-form="disabledForm"
              @change-files="emitChangeFiles"
              @save-form="saveform_trigger = !saveform_trigger"
            />
            <v-row>
              <v-col cols="12">
                <h3 class="mt-15 mb-0">
                  {{ $t("title.articleData") }}
                </h3>
              </v-col>
            </v-row>
            <div class="required-label">
              <h5 class="mb-2">{{ $t("form.article.journal") }}</h5>
              <v-chip x-small outlined color="primary">
                {{ $t("form.mandatory") }}
              </v-chip>
            </div>
            <v-row>
              <v-col cols="12" class="py-0">
                <v-combobox
                  v-model="journalSelected"
                  :items="journals"
                  item-text="title"
                  :label="''"
                  :placeholder="$t('form.article.journal')"
                  return-object
                  :clearable="!disabledForm"
                  outlined
                  :readonly="disabledForm"
                  :rules="rules.fieldRequired"
                ></v-combobox>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="py-0">
                <div class="required-label">
                  <h5 class="mb-2">
                    {{ $t("form.article.publication_status") }}
                  </h5>
                  <v-chip x-small outlined color="primary">
                    {{ $t("form.mandatory") }}
                  </v-chip>
                </div>
                <v-select
                  outlined
                  v-model="publication.article.publication_status"
                  :label="''"
                  :placeholder="$t('form.article.publication_status')"
                  :rules="rules.fieldRequired"
                  :items="publicationStatus"
                  :readonly="disabledForm"
                  item-value="value"
                  item-text="text"
                />
              </v-col>
            </v-row>
            <h5>{{ $t("label.dates") }}</h5>
            <v-row>
              <v-col cols="12" sm="4" class="py-0">
                <div class="required-label">
                  <h6 class="mb-0">
                    {{ $t("form.article.accepted_date") }}
                  </h6>
                  <v-chip x-small outlined color="primary">
                    {{ $t("form.mandatory") }}
                  </v-chip>
                </div>
                <v-menu
                  v-model="menu_accepted_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.article.accepted_date"
                      :label="''"
                      :placeholder="$t('form.article.accepted_date')"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                      :rules="rules.fieldRequired"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.article.accepted_date"
                    @input="menu_accepted_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <h6 class="mb-2">
                  {{ $t('form.article.online_publication_date') }}
                </h6>
                <v-menu
                  v-model="menu_publication_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.article.online_publication_date"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.article.online_publication_date"
                    @input="menu_publication_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4" class="py-0">
                <h6 class="mb-2">
                  {{ $t('form.article.final_publication_date') }}
                </h6>
                <v-menu
                  v-model="menu_final_publication_date"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                  :disabled="disabledForm"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      outlined
                      v-model="publication.article.final_publication_date"
                      prepend-inner-icon="event"
                      readonly
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="publication.article.final_publication_date"
                    @input="menu_final_publication_date = false"
                    :readonly="disabledForm"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <h5 class="form-section-title">{{ $t("form.article.journal_location") }}</h5>
            <v-row>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.article.journal_location.issue_number"
                  :label="$t('form.article.issueNumber')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.article.journal_location.volume"
                  :label="$t('form.article.volume')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.article.journal_location.page_number"
                  :label="$t('form.article.pageNumber')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" lg="3" class="py-0">
                <v-text-field
                  v-model="publication.article.journal_location.pages"
                  :label="$t('form.article.pages')"
                  required
                  outlined
                  :readonly="disabledForm"
                ></v-text-field>
              </v-col>
            </v-row>
            <div class="required-label">
                  <h5 class="mb-2">
                    {{ $t("form.article.feder_acknowledgements") }}
                  </h5>
              <v-chip x-small outlined color="primary">
                {{ $t("form.mandatory") }}
              </v-chip>
            </div>
            <v-row>
              <v-col class="py-0">
                <v-checkbox
                  class="big"
                  v-model="publication.article.feder_acknowledgements"
                  :label="$t('form.federAcknowledgementsDetail')"
                  :readonly="disabledForm"
                  :true-value="true"
                  :false-value="false"
                  :indeterminate="publication.article.feder_acknowledgements === ''"
                  :rules="rules.checkboxRequired"
                />
              </v-col>
            </v-row>
            <v-divider />
            <UserFormActions
              form_name_text="New publication"
              :form_name="form_name"
              :refForm="$refs.form"
              :object_type="object_type"
              :data="processData"
              :state="state"
              :saveform_trigger="saveform_trigger"
              @change-state="changeState"
              :paginated-form="true"
              class="text-center mt-6"
            />
          </v-form>
        </v-card>
  </div>
</template>

<script>
import axios from "axios";
import RejectCommentLayout from "../../layouts/RejectCommentLayout";
import UserFormActions from "../../action_buttons/UserFormActions";
import changeState from "../../../mixins/changeState";
import validationRules from "../../../mixins/validationRules";
import NewPublication from "./NewPublication";
import publication_model from "../../../mixins/model_utils/publication_model";
import publication_data from "../../../mixins/publication_data";
import SearchScopusForm from "@/components/reusables/SearchScopusForm";

export default {
  mixins: [changeState, validationRules, publication_data, publication_model],
  components: {
    NewPublication,
    RejectCommentLayout,
    UserFormActions,
    SearchScopusForm
  },

  data: () => ({
    form_name: "newArticleForm",
    menu: false,
    saveform_trigger: false,
    state: "",
    reject_comment: "",
    object_id: null,
    object_type: "publication",
    menu_accepted_date: false,
    menu_publication_date: false,
    menu_final_publication_date: false,
    journalSelected: null,
    modOp_id: null
  }),

  created() {
    this.getPublicationStatus();
    this.getJournals();
  },

  watch: {
    journals() {
      if (this.updatePublication || this.updatePublicationForm) {
        this.getPublication();
      } else {
        if (this.$store.getters.user !== null) {
          this.loadDefaultAuthor();
        }
      }
    }
  },

  computed: {
    updatePublicationForm() {
      return this.$route.params.id > -1 && !this.updatePublication;
    },
    updatePublication() {
      return this.$route.params.id > -1 && this.$route.meta.update;
    },
    disabledForm() {
      let states = ["VD", "PA", "PV", "PC"];
      return states.includes(this.state);
    },
    processData() {
      let journal = "";
      if (this.journalSelected !== null && this.journalSelected !== undefined) {
        if (typeof this.journalSelected == "string") {
          journal = {
            id: null,
            title: this.journalSelected
          };
        } else if (this.journalSelected.id != null) {
          journal = this.journalSelected.id;
        } else {
          journal = this.journalSelected;
        }
      } else {
        journal = null;
      }
      let data = {
        title: this.publication.title,
        object_type: this.object_type,
        form_name: this.form_name,
        object_id: this.object_id,
        data: {
          user: {
            publication: {
              title: this.publication.title,
              abstract: this.publication.abstract,
              acknowledgements: this.publication.acknowledgements,
              keywords: this.publication.keywords,
              doi: this.publication.doi,
              isbn: this.publication.isbn,
              authors_text: this.publication.authors_text,
              authorsrel: this.publication.authorsrel,
              num_authors: this.publication.num_authors,
              research_areas: this.publication.research_areas.filter(area => Number.isInteger(area)),
              links: this.publication.links,
              is_external: this.publication.is_external,
              hidden: this.publication.hidden,
              featured: this.publication.featured,
              language: this.publication.language,
              minerva_sync_option: this.publication.minerva_sync_option,
              regional: this.publication.regional,
              national: this.publication.national,
              international: this.publication.international,
              files: this.files,
              article: {
                journal: journal,
                accepted_date: this.publication.article.accepted_date,
                online_publication_date: this.publication.article
                  .online_publication_date,
                final_publication_date: this.publication.article
                  .final_publication_date,
                num_pages: this.publication.article.num_pages !== "" ? this.publication.article.num_pages : null,
                publication_status: this.publication.article.publication_status,
                journal_location: this.publication.article.journal_location,
                feder_acknowledgements: this.publication.article
                  .feder_acknowledgements
              }
            }
          }
        }
      };
      return data;
    }
  },

  methods: {
    loadJournalSelected(item) {
      if (item != undefined) {
        if (typeof item == "number") {
          this.journalSelected = this.journals.filter(
            journal => journal.id === item
          )[0];
        } else {
          this.journalSelected = item;
        }
      }
    },
    getPublication() {
      let path =
        this.$store.state.endpoint +
        "/user/moderatedOperations/publication/" +
        this.$route.params.id;
      axios
        .get(path)
        .then(response => {
          this.modOp_id = response.data.id;
          this.publication = response.data.data.user.publication;
          this.normalizePublicationDefaults(this.publication);
          this.state = response.data.state;
          this.reject_comment = response.data.reject_comment;
          this.object_id = response.data.object_id;
          this.loadJournalSelected(this.publication.article.journal);
        })
        .catch(error => {
          console.log(error);
        });
    },
    handleScopusData(data) {
      this.publication.abstract = data.abstract;
      this.publication.keywords = data.keywords;
      this.publication.authors_text = data.authors_text;
      this.publication.num_authors = data.num_authors;
      this.publication.doi = data.doi;
      this.publication.article.final_publication_date = data.publication_date;
      this.publication.article.journal = { id: null, title: data.journal };
      this.loadJournalSelected({ id: null, title: data.journal });
      this.publication.journal_location = {volume: data.volume, pageNumber: data.page_range };
      this.publication.links.publisher = data.url;
      this.publication.title = data.title;
    },
  }
};
</script>

<style scoped>
.required-label {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.required-label .v-chip {
  margin-left: 8px;
}

.form-section-title {
  margin-bottom: 0.85rem;
}
</style>
